_ = require('lodash')

StrokeAnalysisService = ->
  convertStrokeDataForChart: (data) ->
    par5:
      y1: (data.avg_shot_par5 * 100) / 10
      y2: ((10 - data.avg_shot_par5) * 100) / 10
    par4:
      y1: (data.avg_shot_par4 * 100) / 8
      y2: ((8 - data.avg_shot_par4) * 100) / 8
    par3:
      y1: (data.avg_shot_par3 * 100) / 6
      y2: ((6 - data.avg_shot_par3) * 100) / 6

module.exports = StrokeAnalysisService


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/stroke-analysis/stroke-analysis-service.coffee